import axios from "axios";
import { isDevMode } from "Common/debug/debug";
import isString from "lodash/isString";
import replace from "lodash/replace";
import paths from "paths";
axios.interceptors.response.use(async (response) => {
    const { data } = response;
    if (isString(data)) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const contentDiv = doc.querySelector("#content");
        if (contentDiv) {
            const error = contentDiv.getAttribute("data-error");
            const title = contentDiv.getAttribute("data-title");
            const code = contentDiv.getAttribute("data-code");
            const decodedError = error ? decodeURIComponent(error) : "";
            const decodedCode = code ? decodeURIComponent(code) : "";
            const decodedTitle = title ? decodeURIComponent(title) : "";
            window.location.href = replace(replace(paths.error, ":code?", decodedCode), ":title?", decodedError !== null && decodedError !== void 0 ? decodedError : decodedTitle);
        }
    }
    const { unauthorized } = response.headers;
    const { status } = response;
    if (status === 401 || unauthorized === "Unauthorized") {
        window.location.href = paths.login;
    }
    if (isDevMode && window.apiDelay)
        await new Promise(res => {
            setTimeout(res, (window.apiDelay || 0) * 1000);
        });
    return response;
}, async (error) => {
    throw error;
});
